import { render } from "./TeamAudit.vue?vue&type=template&id=7dc570d8&scoped=true"
import script from "./TeamAudit.vue?vue&type=script&lang=js"
export * from "./TeamAudit.vue?vue&type=script&lang=js"

import "./TeamAudit.vue?vue&type=style&index=0&id=7dc570d8&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc570d8"]])

export default __exports__